import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { Invite } = await import('./index');
    return {
        Component: Invite,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
